/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { OutFilterDTO } from "./OutFilterDTO";
import { OutFilterDTOFromJSON, OutFilterDTOFromJSONTyped, OutFilterDTOToJSON } from "./OutFilterDTO";

/**
 *
 * @export
 * @interface FilterResponseDTO
 */
export interface FilterResponseDTO {
  /**
   *
   * @type {Array<OutFilterDTO>}
   * @memberof FilterResponseDTO
   */
  filters?: Array<OutFilterDTO>;
}

/**
 * Check if a given object implements the FilterResponseDTO interface.
 */
export function instanceOfFilterResponseDTO(value: object): boolean {
  let isInstance = true;

  return isInstance;
}

export function FilterResponseDTOFromJSON(json: any): FilterResponseDTO {
  return FilterResponseDTOFromJSONTyped(json, false);
}

export function FilterResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterResponseDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    filters: !exists(json, "filters") ? undefined : (json["filters"] as Array<any>).map(OutFilterDTOFromJSON)
  };
}

export function FilterResponseDTOToJSON(value?: FilterResponseDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    filters: value.filters === undefined ? undefined : (value.filters as Array<any>).map(OutFilterDTOToJSON)
  };
}
